module.exports = __webpack_public_path__ + "img/aParty_1208_A.f40aef32.jpg";